module.exports = __webpack_public_path__ + "img/inbox.0c7b02ed.svg";